import {
  IMAGE_UPLOAD,
  GIF_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
  PDF_UPLOAD,
} from "./types";
export const ContentTypes = [
  { value: IMAGE_UPLOAD, label: "Upload an image" },
  { value: GIF_UPLOAD, label: "Upload a gif" },
  { value: VIDEO_UPLOAD, label: "Upload your own video file" },
  { value: YOUTUBE_URL, label: "Youtube video embed" },
];
export const NoteContentTypes = [
  { value: IMAGE_UPLOAD, label: "Upload an image" },
  { value: PDF_UPLOAD, label: "Upload a pdf" },
  { value: VIDEO_UPLOAD, label: "Upload your own video file" },
  { value: YOUTUBE_URL, label: "Youtube video embed" },
];
export const TokenTypes = [
  { value: "shopping", label: "Shopping token" },
  { value: "premier", label: "Premier token" },
];
export const titles = {
  explore: "Explore",
  support: "Support",
  tokenPay: "TokenPay",
  feeds: "Forum",
  polls: "Polls",
  friends: "Friends",
  community: "Members",
  events: "Events",
  reviews: "Reviews",
  wallet: "Wallet",
  tokenwallet: "Token Wallet",
  cardwallet: "Card Wallet",
  bankwallet: "Bank Wallet",
  ecopay: "Spend Tokens",
  tokenOffers: "Token Offers",
  discountOffers: "Discount Offers",
  earnTokens: "Earn Tokens",
  shop: "Store",
  saving: "Saving Calculator",
  myId: "My ID",
  timeline: "Timeline",
  task_subsite: "Task sub-site",
  task_submission: "Task submission",
};
export const pagesBySection = {
  marketplaceTabs: {
    displayname: "Marketplace",
    tabs: {
      shop: {
        id: "shop",
        name: "Shop",
      },
    },
  },
  supportTabs: {
    displayname: "Support",
    tabs: {
      explore: {
        id: "explore",
        name: "Explore",
      },
      support: {
        id: "support",
        name: "Support",
      },
    },
  },
  profileTabs: {
    displayname: "Profile",
    tabs: {
      myId: {
        id: "profile",
        name: "iD",
      },
      friends: {
        id: "friends",
        name: "Friends",
      },
      tokenwallet: {
        id: "tokenwallet",
        name: "Token Wallets",
      },
      cardwallet: {
        id: "cardwallet",
        name: "Card Wallets",
      },
      bankwallet: {
        id: "bankwallet",
        name: "Bank Wallets",
      },
      timeline: {
        id: "timeline",
        name: "My Timeline",
      },
    },
  },
  communityTabs: {
    displayname: "Community",
    tabs: {
      feeds: {
        id: "feeds",
        name: "Feeds",
      },
      polls: {
        id: "polls",
        name: "Polls",
      },
      community: {
        id: "messages",
        name: "Members",
      },
      events: {
        id: "events",
        name: "Events",
      },
      reviews: {
        id: "review",
        name: "Reviews",
      },
    },
  },
  shoppingTabs: {
    displayname: "Rewards",
    tabs: {
      tokenPay: {
        id: "ecopay",
        name: "Ecopay",
      },
      ecopay: {
        id: "ecopay",
        name: "Spend Tokens",
      },
      tokenOffers: {
        id: "spend",
        name: "Token Offers",
      },
      discountOffers: {
        id: "discounts",
        name: "Discount Offers",
      },
      earnTokens: {
        id: "earn",
        name: "Earn Token",
      },
    },
  },
  otherTabs: {
    displayname: "Others",
    tabs: {
      saving: {
        id: "savingrobot",
        name: "Saving Robot",
      },
      task_subsite: {
        id: "taskerlandingsite",
        name: "Tasker Landing Site",
      },
      task_submission: {
        id: "taskers",
        name: "Tasker",
      },
    },
  },
};
export const pages = {
  explore: {
    id: "explore",
    name: "Explore",
  },
  support: {
    id: "support",
    name: "Support",
  },
  articles: {
    id: "articles",
    name: "Articles",
  },
  checklist: {
    id: "checklist",
    name: "Checklist",
  },
  tokenPay: {
    id: "ecopay",
    name: "Ecopay",
  },
  sectorConcierge: {
    id: "tickets",
    name: "Sector Concierge",
  },
  feeds: {
    id: "feeds",
    name: "Feeds",
  },
  polls: {
    id: "polls",
    name: "Polls",
  },
  friends: {
    id: "friends",
    name: "Friends",
  },
  community: {
    id: "messages",
    name: "Members",
  },
  events: {
    id: "events",
    name: "Events",
  },
  reviews: {
    id: "review",
    name: "Reviews",
  },
  cardWallet: {
    id: "cardwallet",
    name: "Card Wallet",
  },
  wallet: {
    id: "wallets",
    name: "Wallets",
  },
  ecopay: {
    id: "ecopay",
    name: "Spend Tokens",
  },
  tokenOffers: {
    id: "spend",
    name: "Token Offers",
  },
  discountOffers: {
    id: "discounts",
    name: "Discount Offers",
  },
  earnTokens: {
    id: "earn",
    name: "Earn Token",
  },
  shop: {
    id: "shop",
    name: "Shop",
  },
  saving: {
    id: "savingrobot",
    name: "Saving Robot",
  },
  myId: {
    id: "profile",
    name: "iD",
  },
  timeline: {
    id: "timeline",
    name: "My Timeline",
  },
  task_subsite: {
    id: "taskerlandingsite",
    name: "Tasker Landing Site",
  },
  task_submission: {
    id: "taskers",
    name: "Tasker",
  },
  iframe: {
    id: "iframe",
    name: "Iframe",
  },
};
export const gender = ["Male", "Female"];
export const profession = [
  "Accountant",
  "Actor / Actress",
  "Architect",
  "Artist",
  "Astronomer",
  "Author",
  "Baker",
  "Bricklayer",
  "Bus driver",
  "Butcher",
  "Carpenter",
  "Chef/Cook",
  "Cleaner",
  "Dentist",
  "Designer",
  "Doctor",
  "Electrician",
  "Engineer",
  "Entrepreneur",
  "Factory worker",
  "Farmer",
  "Fire fighter",
  "Fisherman",
  "Florist",
  "Gardener",
  "Hairdresser",
  "Influencer",
  "Insurer",
  "Journalist",
  "Judge",
  "Lawyer",
  "Lecturer",
  "Librarian",
  "Lifeguard",
  "Marketeer",
  "Model ",
  "Newsreader",
  "Nurse",
  "Optician",
  "Painter",
  "Pharmacist",
  "Photographer",
  "Pilot",
  "Plumber",
  "Police",
  "Politician",
  "Postman",
  "Real estate",
  "Receptionist",
  "Refuse collector",
  "Sales",
  "Scientist",
  "Secretary",
  "Shop assistant",
  "Soldier",
  "Tailor",
  "Taxi driver",
  "Teacher",
  "Traffic warden",
  "Translator",
  "Travel agent",
  "Vet",
  "Waiting",
  "Window cleaner",
];
export const admin_types = [
  "Account manager",
  "Chat support agent",
  "Commercial admin",
  "Content Admin",
  "Content and marketing",
  "Sales manager",
  "Sales rep",
  "Service manager",
  "Service rep",
  "Super admin",
  "Marketplace lister",
];
export const user_origin_types = [
  "Existing customer base",
  "Community referral",
  "Client referral",
  "Printed - Flyering",
  "Printed - Posted",
  "Digital - Radio",
  "Digital - TV",
  "Social media - Facebook",
  "Social media - Instagram",
  "Social media - Twitter",
  "Social media - Linkedin",
];
export const user_access = [
  { value: "Sales prospect", label: "Prospect - Sales" },
  { value: "Referred prospect", label: "Prospect - Referred" },
  {
    value: "Registered prospect",
    label: "Prospect - Registered (via cell phone)",
  },
  {
    value: "Registered prospect email",
    label: "Prospect - Registered (via email)",
  },
  { value: "Dormant", label: "Prospect - Dormant" },
  { value: "Pending member", label: "Member - Pending" },
  { value: "Canceled", label: "Prospect/Member - Canceled" },
  { value: "Member", label: "Member - Customer" },
  { value: "Brandname employee", label: "Member - Employee" },
  { value: "Friend of brandname", label: "Member - Friend" },
];

export const sales_user_access = [
  { value: "Sales prospect", label: "Prospect - Sales" },
  { value: "Pending member", label: "Member - Pending" },
  { value: "Canceled", label: "Prospect/Member - Canceled" },
];

export const noteOptions = [
  { value: "appointment", label: "Appointment" },
  { value: "delivery", label: "Delivery/access" },
  { value: "contact", label: "Contact information" },
  { value: "financial", label: "Financial" },
  { value: "product", label: "Product/Marketplace" },
  { value: "insurance", label: "Insurance" },
  { value: "review", label: "Review" },
  { value: "complaint", label: "Complaint" },
  { value: "completion_by_member", label: "Completion signed off by member" },
  { value: "completion_by_admin", label: "Completion signed off by admin" },
  { value: "assign_tokens", label: "Assign tokens" },
  { value: "request_img", label: "Image request" },
  { value: "request_pdf", label: "PDF request" },
  { value: "request_video", label: "Video request" },
  { value: "question", label: "Question" },
  { value: "complete-concierge", label: "Question of experience feedback" },
  { value: "yes_no_choice", label: "Question of yes or no choice" },
  { value: "request_checkin", label: "Request check-in" },
];
export const perkTypes = [
  "Broadcast a retailer token offer",
  "Broadcast a limited time perk",
];

export const IframeTypes = [
  { value: "generic", label: "Generic" },
  { value: "uid_plus", label: "UID plus" },
];



// WEBPACK FOOTER //
// ./src/Constants/selections.js